module.exports = __webpack_public_path__ + "static/media/moons_ortodoncia_invisible-960.237e38e3.webp";